import { Component } from '@angular/core';

/**
 * Component for quoter layout header
 * @export
 * @class OrgLayoutQuoterHeaderComponent
 */
@Component({
  selector: 'org-layout-quoter-header',
  templateUrl: './org-layout-quoter-header.component.html',
  styleUrls: ['./org-layout-quoter-header.component.scss'],
})
export class OrgLayoutQuoterHeaderComponent {

}
